import { IClientConfigs, IVehiclePaint } from '~/shared';
import { CategoryTypes } from '../../components/CategoryTab';
import { IListItem } from '../../components/ListTab';
import { createSlice } from '../wrappers';

interface CarPaintSlice {
	activeStage: 'category' | 'list' | 'paint';
	activeCategory: CategoryTypes | null;
	maxCategoryIndex: number;
	activeList: IListItem[];
	activeListIndex: number | null;
	maxListIndex: number;
	activePaintGroup: IClientConfigs['vehiclesPaint']['types'][number] | null;
	ownedVehiclePaint: IVehiclePaint | null;
	interfaceHidden: boolean;
}

const initialState: CarPaintSlice = {
	activeStage: 'category',
	activeCategory: CategoryTypes.PaintingWorks,
	maxCategoryIndex: 3,
	activeList: [] as IListItem[],
	activeListIndex: null,
	maxListIndex: 0,
	activePaintGroup: null,
	ownedVehiclePaint: null,
	interfaceHidden: false,
};

const carPaintSlice = createSlice({
	name: 'carPaint',
	initialState,
	reducers: {
		setActiveStage: (state, action) => {
			state.activeStage = action.payload;
		},
		setActiveListIndex: (state, action) => {
			state.activeListIndex = action.payload;
		},
		setMaxListIndex: (state, action) => {
			state.maxListIndex = action.payload;
		},
		setActiveList: (state, action) => {
			state.activeList = action.payload;
		},
		setActiveCategory: (state, action) => {
			state.activeCategory = action.payload;
		},
		setActivePaintGroup: (state, action) => {
			state.activePaintGroup = action.payload;
		},
		setOwnedVehiclePaint: (state, action) => {
			state.ownedVehiclePaint = action.payload;
		},
		setInterfaceHidden: (state, action) => {
			state.interfaceHidden = action.payload;
		},
	},
});

export const {
	setActiveStage,
	setActiveListIndex,
	setMaxListIndex,
	setActiveList,
	setActiveCategory,
	setActivePaintGroup,
	setOwnedVehiclePaint,
	setInterfaceHidden,
} = carPaintSlice.actions;

export default carPaintSlice.reducer;
